module.exports = __webpack_public_path__ + "fonts/Theinhardt-Light.2829823.woff2";